import React from "react";

import { REVIEWED_DATA_POINT_CROP, REVIEWED_DATA_POINT_ORGANIC_FERTILIZER, ReviewedDataPoint } from "models";

import { Form, Option, Select } from "components";

export const CROP_REVIEWED_DATA_POINT_OPTIONS: { value: ReviewedDataPoint; label: string }[] = [
  { value: REVIEWED_DATA_POINT_CROP.cropType, label: "Crop type" },
  { value: REVIEWED_DATA_POINT_CROP.yield, label: "Yield" },
  { value: REVIEWED_DATA_POINT_CROP.residue, label: "Residue" },
  { value: REVIEWED_DATA_POINT_CROP.dryMass, label: "Dry mass" },
  { value: REVIEWED_DATA_POINT_CROP.seedingDates, label: "Seeding dates" },
  { value: REVIEWED_DATA_POINT_CROP.harvestDates, label: "Harvest dates" },
];

export const ORGANIC_FERTILIZER_REVIEWED_DATA_POINT_OPTIONS: { value: ReviewedDataPoint; label: string }[] = [
  { value: REVIEWED_DATA_POINT_ORGANIC_FERTILIZER.fertilizerType, label: "Fertilizer type" },
  { value: REVIEWED_DATA_POINT_ORGANIC_FERTILIZER.amount, label: "Amount" },
  { value: REVIEWED_DATA_POINT_ORGANIC_FERTILIZER.nValue, label: "N value" },
  { value: REVIEWED_DATA_POINT_ORGANIC_FERTILIZER.applicationDates, label: "Application dates" },
  { value: REVIEWED_DATA_POINT_ORGANIC_FERTILIZER.selfProduced, label: "Self produced" },
  { value: REVIEWED_DATA_POINT_ORGANIC_FERTILIZER.application, label: "Application method" },
];

interface ReviewedDataPointsDropdownProps {
  reviewedDataPoints: ReviewedDataPoint[] | null;
  practiceId: string;
  options: { value: ReviewedDataPoint; label: string }[];
  onChange: (practiceId: string, reviewedDataPoints: ReviewedDataPoint[] | null) => void;
}

export const ReviewedDataPointsDropdown = ({ reviewedDataPoints, practiceId, options, onChange }: ReviewedDataPointsDropdownProps) => {
  const handleChange = (newValues: ReviewedDataPoint[]) => {
    onChange(practiceId, newValues.length > 0 ? newValues : null);
  };

  return (
    <Form name={`reviewed-data-points-form-${practiceId}`}>
      <Select
        name={`reviewed-data-points-${practiceId}`}
        mode="multiple"
        initialValue={reviewedDataPoints ?? []}
        onChange={handleChange}
        className="verification-select"
        placeholder="All"
        onClick={(e) => e.stopPropagation()}
      >
        {options.map(({ value, label }) => (
          <Option key={value} value={value}>
            {label}
          </Option>
        ))}
      </Select>
    </Form>
  );
};
